import { COMMERCIAL_BILLING_NAV_KEYS } from '@/components/SiderMenu/utils/sessionNavigation';

/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'channelCustomerAssignments';

/**
 * Descriptor-only route token (export/tasks disabled).
 * Runtime list/detail base path comes from session navigation (commercial billing).
 */
export const FETCH_ROUTE = 'channel-customer-assignments';

/** Singular entity name for shared helpers / notifications. */
export const ENTITY_NAME = 'channelCustomerAssignment';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'channelCustomerAssignments';

/** Default OData sort when the user clears column sorting. */
export const DEFAULT_ORDER_BY = 'customerCompany/commercialName asc';

/** Session navigation key used to resolve the commercial billing API base path. */
export const NAVIGATION_KEY = COMMERCIAL_BILLING_NAV_KEYS.CUSTOMER_ASSIGNMENTS;
